export const getPageOffset = () => {
  const node = document.documentElement || document.body.parentNode || document.body;
  return {
    x: window.pageXOffset !== undefined ? window.pageXOffset : (node as Element).scrollLeft,
    y: window.pageYOffset !== undefined ? window.pageYOffset : (node as Element).scrollTop,
  };
};
